import axios from 'axios';
import { useQuery } from 'react-query';
import { RETRIEVE_APPLICANT } from './constants';
import getBaseApi from '@luna-protocol/core/src/utils/getBaseApi';

export interface ApplicantRes {
  is_primary: boolean;
  customer_id: string;
  first_name: string;
  last_name: string;
  cell_phone_number: string;
  state: string;
  zip_code: string;
  address_lines: string[];
  county: string;
  city: string;
  home_phone_number: string;
  date_of_birth: string;
  social_security_number: string;
  email_address: string;
}

export type ApplicantRequest = {
  loanApplicationID: string;
  isCoapplicant: boolean;
  customerID: string;
};

const getApplicant = async (loanApplicationID: string, customerID: string, isCoapplicant: boolean) => {
  const resp = await axios.get(`${getBaseApi()}/dealer/application/${loanApplicationID}/applicant/${customerID}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('user_token')}` },
  });
  if (resp.status !== 200) {
    throw new Error(`Failed to get ${isCoapplicant ? 'CoApplicant' : 'Primary'} applicant`);
  }
  return resp.data as ApplicantRes;
};

const useGetApplicant = (req: ApplicantRequest) => {
  return useQuery([RETRIEVE_APPLICANT, req.customerID], async () => {
    return await getApplicant(req.loanApplicationID, req.customerID, req.isCoapplicant);
  });
};

export { useGetApplicant };
